import React from 'react'
import AddIcon from '@mui/icons-material/Add'
import Remove from '@mui/icons-material/Remove'
import CancelIcon from '@mui/icons-material/Cancel'
import Edit from '@mui/icons-material/Edit'
import FilterListIcon from '@mui/icons-material/FilterList'
import Delete from '@mui/icons-material/Delete'
import GetAppRoundedIcon from '@mui/icons-material/GetAppRounded'
import OpenWithIcon from '@mui/icons-material/OpenWith';
import LockIcon from '@mui/icons-material/Lock'; // Import LockIcon
import LockOpenIcon from '@mui/icons-material/LockOpen'; // Import LockOpenIcon

import './icons.scss'

export default function Icons(props) {
  let element
  switch (props.icon) {
    case 'add':
      element = <AddIcon />
      break
    case 'remove':
      element = <Remove />
      break
    case 'cancel':
      element = <CancelIcon onClick={props.onClick} />
      break
    case 'edit':
      element = <Edit />
      break
    case 'trash':
      element = <Delete />
      break
    case 'filter':
      element = <FilterListIcon />
      break
    case 'download':
      element = <GetAppRoundedIcon fontSize="small" />
      break
    case 'dragHandle':
      element = < OpenWithIcon className="pan-tool" />
      break
    case 'lock': // Add lock icon case
      element = <LockIcon className='brand-color-5' fontSize='small' />
      break
    case 'unlock': // Add unlock icon case
      element = <LockOpenIcon className='brand-color-2' fontSize='small' />
      break
    default:
  }
  return (
    <div className='icon'>
      {element}
    </div>
  )
}
